export default __webpack_public_path__ + "static/media/live_arr.2bf4ef24.svg";